import "./ClarificationArticlePage2.module.css";
import Header from "@/reusable_sections/Header";
import Breadcrumb from "./sections/Breadcrumb";
import ArticleHeader from "./sections/ArticleHeader";
import LabelKategori from "./sections/LabelKategori";
import OfficialStatementSummary from "./sections/OfficialStatementSummary";
import MetaInformasiLengkap from "./sections/MetaInformasiLengkap";
import BoxStatusKlarifikasi from "./sections/BoxStatusKlarifikasi";
import BookContent from "./sections/BookContent";
import OfficialQuote from "./sections/OfficialQuote";
import DokumenReferensi from "./sections/DokumenReferensi";
import Closing from "./sections/Closing";
import RelatedArticles from "./sections/RelatedArticles";
import Footer from "@/reusable_sections/Footer";
export default function ClarificationArticlePage2() {
  return <div>
      <Header />
      <Breadcrumb />
      <ArticleHeader />
      <LabelKategori />
      <OfficialStatementSummary />
      <MetaInformasiLengkap />
      <BoxStatusKlarifikasi />
      <BookContent />
      <OfficialQuote />
      <DokumenReferensi />
      <Closing />
      <RelatedArticles />
      <Footer />
    </div>;
}